import { Link } from "@tanstack/react-router";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS, CONTACT_PATH, routeTo } from "@/lib/site";
import { MaskReveal, Reveal } from "../Reveal";
import { ACTIVITY_GALLERY } from "./galleryData";

const GROUPS = [
  "Family Reunions",
  "Birthday Celebrations",
  "Fishing Groups",
  "Holiday Gatherings",
  "Business Meetings",
  "Corporate and Worker Stays",
  "Seasonal Community Events",
  "Extended Group Stays",
] as const;

export function EventsGroupsSection() {
  const photo = ACTIVITY_GALLERY[4]!;

  return (
    <section
      className="texture-paper bg-background py-24 sm:py-28 lg:py-32"
      aria-labelledby="events-groups-title"
    >
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <div>
          <Reveal>
            <p className="eyebrow text-clay">Bring Everyone Together</p>
            <h2
              id="events-groups-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              A Welcoming Setting for Groups and Celebrations
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
              <p>
                Amigo Inn &amp; RV Park welcomes family reunions, birthday celebrations, fishing
                groups, holiday gatherings, business meetings, work crews, and other group stays.
              </p>
              <p>
                Guests can enjoy the recreation hall, game room, covered picnic area, barbecue pits,
                and comfortable accommodation options throughout the property.
              </p>
              <p>
                Whether you are planning one special afternoon or coordinating accommodations for a
                longer group visit, contact our team to discuss your needs and current availability.
              </p>
            </div>
          </Reveal>

          <ul className="mt-9 flex flex-wrap gap-2.5">
            {GROUPS.map((item, i) => (
              <Reveal as="li" key={item} delay={i * 0.04}>
                <span className="inline-flex rounded-full border border-forest/20 bg-surface px-4 py-2 text-xs font-semibold text-forest-deep">
                  {item}
                </span>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.1} className="mt-10 flex flex-wrap items-center gap-4">
            <Button asChild variant="forest" size="cta">
              <Link to={routeTo(CONTACT_PATH)}>
                Plan Your Gathering <ArrowRight aria-hidden="true" />
              </Link>
            </Button>
            <a
              href={BUSINESS.phoneHref}
              className="link-underline text-sm font-semibold text-forest"
            >
              <Phone className="size-4" aria-hidden="true" /> Call {BUSINESS.phone}
            </a>
          </Reveal>
        </div>

        <MaskReveal className="media-zoom rounded-sm">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes="(min-width: 1024px) 45vw, 100vw"
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[5/4] w-full rounded-sm object-cover"
          />
        </MaskReveal>
      </div>
    </section>
  );
}
